var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ccn-cookie-additional-details",class:("ccn-cookie-additional-details--" + _vm.size)},[_vm._v(_vm._s(_vm.title)+": "+_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }